<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        :disabled="selectedPlayers.length === 0"
        class="text-capitalize"
        color="primary"
        text
        small
      >
        {{ $t("freespins.viewSelectedPlayers") }}
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        {{ $t("freespins.selectedPlayers") }}

        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="py-2">
        <span class="text-subtitle-1">
          {{ $t("freespins.totalSelectedPlayers") }}
          <strong>
            {{ selectedPlayers.length }}
          </strong>
        </span>

        <div style="max-height: 350px; overflow-y: auto; padding: 0.5rem;">
          <div
            v-for="player in selectedPlayers"
            :key="player.id"
            class="d-flex flex-column "
            style="max-width: 95%"
          >
            <span> ID: {{ player.id }} </span>
            <span> Login: {{ player.login }} </span>
            <span> {{ $t("name") }}: {{ player.name }} </span>
            <v-divider class="my-2" />
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    selectedPlayers: {
      type: Array,
    },
  },

  data: () => ({
    dialog: false,
  }),

  methods: {
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
